import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product-recycle",
  "use": "icon-product-recycle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-product-recycle\"><defs><style></style></defs><path d=\"M896 256v576a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V256H64v-64h192v-64a64 64 0 0 1 64-64h384a64 64 0 0 1 64 64v64h192v64h-64zM704 128H320v64h384v-64zm128 128H192v576a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V256zM576 384h64v384h-64V384zm-192 0h64v384h-64V384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol